import { useState, useEffect } from "react";

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(storedValue));
  }, [key, storedValue]);

  // ✅ Fix: Wrap setStoredValue in a function
  const updateStoredValue = (value) => {
    setStoredValue((prev) => {
      const newValue = typeof value === "function" ? value(prev) : value;
      return newValue;
    });
  };

  return [storedValue, updateStoredValue];
}

export default useLocalStorage;
